<template>
    <b-grid
        caption="Agencies"
        :tableOptions="agencyStore.tableOptions"
        :filterableFields="agencyStore.filterableFields"
        :filterOptions="agencyStore.filterOptions"
        @optionChange="getData"
        :items="agencyStore.items"
        :columns="columns"
        :loading="loading">
        <template #beforeFilter>
            <b-button
                v-if="canAdd"
                to="AgencyDetails.aspx"
                >Add a new agency</b-button
            >
        </template>

        <template #cell.ori="{item}">
            <a :href="`AgencyDetails.aspx?id=${item.ori}`">{{ item.ori }}</a>
        </template>

        <template #cell.agencyName="{item}">
            <a :href="`AgencyDetails.aspx?id=${item.ori}`">{{ item.oriName }}</a>
        </template>
        <!-- <template #cell.dataCollection="{item}">
            {{ item.dataCollectionStatus }}
        </template> -->

        <template #cell.actions="{item}">
            <div class="button-wrapper">
                <b-button
                    v-if="canEdit"
                    :to="`AgencyDetails.aspx?id=${item.ori}`"
                    size="sm">
                    Edit
                </b-button>
            </div>
        </template>
        <template #pagingStart>
            <div
                class="btn-group"
                role="group">
                <drop-down
                    label="Export Data"
                    :item-count="2"
                    :is-primary-button="true">
                    <template v-slot:item1="{item}">
                        <button
                            class="dropdown-item"
                            @click.prevent="exportData('csv')">
                            Download as .csv
                        </button>
                    </template>
                    <template v-slot:item2="{item}">
                        <button
                            class="dropdown-item"
                            @click.prevent="exportData('xlsx')">
                            Download as .xlsx
                        </button>
                    </template>
                </drop-down>
            </div>
        </template>
    </b-grid>

    <system-alerts></system-alerts>
    <confirm-modal></confirm-modal>
</template>
<script setup lang="ts">
import {computed, onMounted, ref} from "vue";
import {BTableColumn} from "./BTable/BTable.types";
import {SystemAlerts, ConfirmModal} from "./Misc";
import BGrid from "./BGrid/BGrid.vue";

import {BButton} from "./BButton";
import DropDown from "@/components/Misc/DropDown.vue";
import {saveFile} from "@/composable/filesHelper";
import {storeToRefs} from "pinia";
import {useAgencyStore} from "@/stores/agencyStore";
import hasPermission from "@/composable/permissionHelper";

const agencyStore = useAgencyStore();
const {loading} = storeToRefs(agencyStore);

const canAdd = computed(() => {
    return hasPermission("AddAgency");
});
const columns = ref<BTableColumn[]>([
    {
        key: "ori",
        text: "ORI",
        sortable: true,
        columnClass: ["align-middle"],
        class: (item) => ["text-nowrap"],
        value: (item) => item.ori,
    },

    {
        key: "agencyName",
        text: "Agency Name",
        sortable: true,
        columnClass: ["align-middle"],
        class: (item) => ["text-nowrap"],

        value: (item) => item.oriName,
    },
    {
        key: "agencyType",
        text: "Agency Type",
        sortable: false,
        columnClass: ["align-middle"],

        class: (item) => ["text-nowrap"],
        value: (item) => item.agencyType,
    },
    {
        key: "county",
        text: "County",
        sortable: false,
        columnClass: ["align-middle"],

        class: (item) => ["text-nowrap"],
        value: (item) => item.countyName,
    },
    {
        key: "dataCollection",
        text: "Active Data Collections",
        sortable: false,
        columnClass: ["align-top", "text-center"],
        class: (item) => ["text-nowrap"],
        value: (item) => item.dataCollectionStatus,
        children: [
            {
                key: "label",
                text: "Label",
                sortable: false,
                columnClass: ["align-top"],
                class: (subitem) => ["text-nowrap"],
                subRowValue: (_, row) => row.label,
            },
            {
                key: "startDate",
                text: "Start Date",
                sortable: false,
                columnClass: ["align-top"],
                class: (subitem) => ["text-nowrap"],
                subRowValue: (_, row) => row.startDate,
            },
            {
                key: "vendorName",
                text: "Vendor Name",
                sortable: false,
                columnClass: ["align-top"],
                class: (subitem) => ["text-nowrap"],
                subRowValue: (_, row) => row.vendorName,
            },
        ],
    },
]);

const canEdit = computed(() => {
    return true;
});

const exportData = async (type: string) => {
    let blob = await agencyStore.exportFile(type);
    saveFile(`agencies.${type}`, blob);
};

const getData = async () => {
    await agencyStore.list();
};

onMounted(async () => {
    await getData();
});
</script>
<style>
.agency-access {
    font-size: 0.9rem;
}
</style>
